module.exports = __webpack_public_path__ + "static/img/5.3f0b5f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/5.jpg
// module id = we9r
// module chunks = 1